import { render, staticRenderFns } from "./ShiftlyHeader.vue?vue&type=template&id=2eb5422a&scoped=true&"
import script from "./ShiftlyHeader.vue?vue&type=script&lang=js&"
export * from "./ShiftlyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb5422a",
  null
  
)

export default component.exports